import { GatsbyBrowser } from 'gatsby';

import { Root, Page } from './src/components/Provider';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = Root;
export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = Page;
// Re-initialize Poptin on client-side navigation so the correct language popup
// (English vs Polish) is triggered based on the new URL. Skipped on first load
// because gatsby-ssr.tsx already injects the pixel script for the initial page.
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ prevLocation }) => {
  if (!prevLocation) return;

  const existing = document.getElementById('pixel-script-poptin');
  if (existing) existing.remove();

  const script = document.createElement('script');
  script.id = 'pixel-script-poptin';
  script.src = 'https://cdn.popt.in/pixel.js?id=d06976c009047';
  script.async = true;
  document.head.appendChild(script);
};
